import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Events } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { Headers, Http, RequestOptions } from '@angular/http';

@Injectable()

export class AuthService {

  public retorno = false;

  constructor(private http: Http, public events: Events) {}
 
  public login(credentials) {
    if (credentials.email === null || credentials.password === null) {
      return Observable.throw("Por favor preencha os campos.");
    } else {
      return Observable.create(observer => {

        let emailUser = credentials.email;
        let passwordUser = credentials.password;

        let headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/x-www-form-urlencoded' );
        let options = new RequestOptions({ headers: headers });
     
        let postParams = {
          email: emailUser,
          senha: passwordUser
        }

        var resultado;


        this.http.post("http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/login", postParams, options)
          .subscribe(data => {
             resultado = JSON.parse(data['_body']);
             if(resultado.id) {
              localStorage.setItem("idUsuario", resultado.id);
              this.getData();
             }
             
            observer.next(resultado.msg == "ok");
            observer.complete();
           }, error => {
              console.log(error);
            });
          });
        }
      }
 
  public logout() {
    return Observable.create(observer => {
      localStorage.removeItem("idUsuario");
      localStorage.removeItem("nomeUsuario");
      localStorage.removeItem("emailUsuario");
      observer.next(true);
      observer.complete();
    });
  }

  public getData() {
    let url = "http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/getUsuario?id="+localStorage.getItem("idUsuario");
    
    this.http.get(url).map(res => res.json()).subscribe(data => {
       localStorage.setItem("nomeUsuario", data.nome);
       localStorage.setItem("emailUsuario", data.email);

       this.events.publish('user:created', localStorage.getItem("nomeUsuario"), localStorage.getItem("emailUsuario"));
    });
  }

  public userExists(email){

    let url = "http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/getUsuario?email="+email;

    this.http.get(url).map(res => res.json()).subscribe(data => {

      if(data.id){
        localStorage.setItem("idUsuario", data.id);
        localStorage.setItem("nomeUsuario", data.nome);
        localStorage.setItem("emailUsuario", data.email);

        this.events.publish('user:created', localStorage.getItem("nomeUsuario"), localStorage.getItem("emailUsuario"));
        this.events.publish('user:exists', localStorage.getItem("nomeUsuario"), localStorage.getItem("emailUsuario"));
      }

    });
  }

  public cadastrar(credentials) {
    if (credentials.nome === null || credentials.email === null || credentials.senha === null) {
      return Observable.throw("Por favor preencha os campos obrigatórios.");
    } else {
      // At this point store the credentials to your backend!
      return Observable.create(observer => {

        let headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        let options = new RequestOptions({ headers: headers });

        let nome = credentials.nome;
        let email = credentials.email;
        let senha = credentials.senha;
        let dataAniversario = credentials.dataAniversario ? credentials.dataAniversario : "";
        let sexo = credentials.sexo ? credentials.sexo : "";
        let ddd = credentials.ddd ? credentials.ddd : "";
        let telefone = credentials.telefone ? credentials.telefone : "";
     
        let postParams = {
          nome: nome,
          email: email,
          senha: senha,
          dataAniversario: dataAniversario,
          sexo: sexo,
          ddd: ddd,
          telefone: telefone
        }

        var resultado;

        this.http.post("http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/setUsuario", postParams, options)
          .subscribe(data => {
            resultado = JSON.parse(data['_body']);

            if(resultado.msg == "OK"){
              localStorage.setItem("idUsuario", resultado.id);
              this.events.publish('user:created', postParams.nome, postParams.email);
              observer.next(true);
              observer.complete();
            } else {
              document.getElementById("erros").innerHTML = resultado.msg;
              observer.next(false);
              observer.complete();
            }
            
           }, error => {
              console.log(error);
              observer.next(false);
              observer.complete();
            });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/auth-service.ts